export default "__VITE_ASSET__BURt7NVQ__"